import { MessageOutlined, UserOutlined } from '@ant-design/icons';
import { ProfileNavItem } from '@app/constants/profileNavData';
import { ADMIN_BASE_BATH } from '@app/constants/variables';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import * as S from './WorkerNav.styles';

const profileNavData: ProfileNavItem[] = [
  {
    id: 1,
    name: 'form.personalInfo',
    icon: <UserOutlined />,
    color: 'primary',
    href: 'personal-info',
  },
  // {
  //   id: 2,
  //   name: 'form.chatInfo',
  //   icon: <WechatWorkOutlined />,
  //   color: 'warning',
  //   href: 'chat-info',
  // },
  {
    id: 2,
    name: 'form.noteInfo',
    icon: <MessageOutlined />,
    color: 'primary',
    href: 'note-info',
  },
];

interface WorkerNavProps {
  baseSlug: string;
  isAdmin: boolean;
}

export const WorkerNav: React.FC<WorkerNavProps> = ({ baseSlug, isAdmin }) => {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();

  const [navData, setNavData] = useState<ProfileNavItem[]>([]);

  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    if (id) {
      setNavData(
        profileNavData
          .filter((item) => (isAdmin ? item.id === 1 : true))
          .map((item) => ({
            ...item,
            name: `${baseSlug}.${item.name}`,
            href: `${item.href}/${id}`,
          })),
      );
    } else {
      setNavData(
        profileNavData
          .filter((item) => item.id === 1)
          .map((item) => ({
            ...item,
            name: `${baseSlug}.${item.name}`,
          })),
      );
    }
  }, [baseSlug, id, isAdmin]);

  return (
    <S.Wrapper>
      {navData.map((item) => (
        <S.Btn
          key={item.id}
          icon={item.icon}
          type="text"
          color={item.color}
          onClick={() => navigate(item.href)}
          isActive={`${ADMIN_BASE_BATH}/${baseSlug}/${item.href}` === location.pathname}
        >
          {`${t(item.name)}`}
        </S.Btn>
      ))}
    </S.Wrapper>
  );
};
